.svgContainer {
  fill: none;
  .orbit,
  .orbitSpin {
    transform-origin: center;
    color: var(--fly-color-scheme-primary-7);
    box-shadow: 0 0 0.728px 0 var(--fly-color-scheme-primary-7) inset;
    fill: linear-gradient(
      180deg,
      var(--fly-color-scheme-primary-6, #40be46) 0%,
      var(--fly-color-scheme-primary-2, #c4ebc6) 100%
    );
  }

  .orbit {
    stroke: var(--fly-color-scheme-primary-5);
    stroke-width: 1;
    opacity: 0.5;
    animation: orbitFade 3s linear infinite; /* smooth fading */
  }

  .orbitSpin {
    stroke: var(--fly-color-scheme-primary-6);
    stroke-width: 1;
    stroke-linecap: round;
    stroke-dasharray: 8 50;
    animation:
      spin 1.5s linear infinite,
      orbitFade 3s linear infinite;
  }

  .zoom {
    animation: pulse 1.5s linear infinite alternate;
    transform-origin: center;
  }

  .spin {
    transform-origin: 6.444px 6.444px;
    animation: spinStars 1.5s linear infinite;
  }

  .spinReverse {
    transform-origin: 12.666px 12.666px;
    animation: spinStarsReverse 2s linear infinite;
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes spinStars {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  @keyframes spinStarsReverse {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }

  @keyframes pulse {
    0% {
      transform: scale(0.6);
      opacity: 0.3;
    }
    100% {
      transform: scale(1.1);
      opacity: 1;
    }
  }

  /* Smooth orbit fade in/out */
  @keyframes orbitFade {
    0% {
      opacity: 0.5;
    }
    33%,
    66% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
}
